import React from 'react';
import LatestTransactions from '../../../../generic-components/LatestTransactions';
import { useStore } from '../../../../store';
import { useEmergencyBucketTransactionsQuery } from '../../../../hooks/query/useEmergencyBucketTransactionsQuery';
import { convertFilterToQueryString, getInitialTransactionsFilters } from '../../../transactions/utils';
import { validateFeatureFlag } from '../../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../../constants/general';

const EmergencyBucketLatestTransactions = () => {
  const PATH = '/emergency-bucket-transactions';
  const { customerId } = useStore(state => state.user);
  const summaryData = useStore(state => state.summary);
  const isEmergencyBucketActive = validateFeatureFlag(FEATURE_FLAG.EMERGENCY_BUCKET) && summaryData.emergencyBucketResponse?.active;
  const query = convertFilterToQueryString(getInitialTransactionsFilters());
  const { data, isLoading } = useEmergencyBucketTransactionsQuery({ customerId, query, enabled: isEmergencyBucketActive });
  const transactionList = !isLoading && data ? data.transactionList.slice(0, 5) : [];
  return (
    <LatestTransactions data={transactionList} isLoading={isLoading} navPath={PATH} />
  );
};

export default EmergencyBucketLatestTransactions;
